import { Button, Grid, MenuItem, TextField as MuiTextField } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { Field, useFormikContext } from "formik";
import { TextField } from 'formik-material-ui';
import { applicationContext } from "helpers/services";
import { useContext } from "react";
import * as yup from "yup";
import { assegneeSuggestionSchema } from "../AssegneeSuggestionContext";
import { Autocomplete } from '@material-ui/lab';


let AssegneeSuggestion = () => {
    let { ticketTypes, assignableUsers } = useContext(applicationContext);

    type TicketSuggestion = yup.InferType<typeof assegneeSuggestionSchema>;
    let form = useFormikContext<TicketSuggestion>();


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        select
                        name="ticketTypeId"
                        label="Typology"
                        variant="outlined"
                        fullWidth
                    >
                        {ticketTypes.map(x => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                    </Field>
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        value={form.values.assignee}
                        onChange={(e, newValue) => form.setFieldValue('assignee', newValue || "")}

                        getOptionLabel={(option) => assignableUsers.getValueByKey(option, 'email', 'name')}
                        options={assignableUsers.map(x => x.email)}
                        renderInput={(params) =>
                            <MuiTextField
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Assignee"
                            />
                        }
                    />
                </Grid>
                <Grid item xs={8}>
                    <Field
                        component={TextField}
                        name="product"
                        label="Product"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="productStatus"
                        label="Product condition"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default AssegneeSuggestion;